<template>
  <div class="hello">

    <menupicker value="rules">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>
    <div class="center green rcorners1">
      <ul class="normalul">
        <li class="normalli" v-for="item in content ">  {{ item }} </li>
      </ul>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';
  import DynamoDb from "aws-sdk/clients/dynamodb";

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

  export default {
    name: 'Rules',
    data() {
      return {
        active: 'rules',
        msg: 'Good For Everyone',
        content: ''
      }
    },
    methods: {
      loadData(awscredentials) {
        const docClient = new DynamoDb.DocumentClient({
          region: localStorage.getItem('region'),
          credentials: awscredentials,
        });

        const query = {
          TableName: 'about-webcontents',
          KeyConditions: {
            pageid: {
              ComparisonOperator: 'EQ',
              AttributeValueList: ['rules']
            }
          }
        }
        return new Promise((resolve, reject) => {
          docClient.query(
            query,
            (error, data) => {
              if (error) {
                console.error('dynamodb error: ' + error.message);
                reject(`dynamodb error: ${error.message}`);
              }
              resolve(data);
            }
          )
        })
      },
      parseData(data){
        console.log(JSON.stringify(data.Items[0].content, null, 2));
        let paras = data.Items[0].content.split('\n');
        this.content = paras;
      },
      initCredentials() {
        const credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: localStorage.getItem('poolid'),
        }, { region: localStorage.getItem('region')});
        return credentials;
      }
    },
    mounted() {
      this.loadData(this.initCredentials())
        .then(data => this.parseData(data));
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    font-size: large;
  }

  ul .link {
    list-style-type: none;
    padding: 0;
  }

  li .link {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 85%;
    text-align: left;
  }

  .center {
    margin: auto;
    margin-top: 5px;
    width: 95%;
    padding: 10px;
  }

  .green {
    border: 3px solid green;
  }

  .normalli {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    text-align: left;
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Rules.vue